/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import 'aisztheme';

import React from 'react';
import { routerActions } from 'react-router-redux';
import { connect } from 'react-redux';
import {
  Button,
  Col,
  ControlLabel,
  Form,
  FormControl,
  FormGroup,
  HelpBlock,
  Grid,
  Panel,
  Row,
} from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import Toolbar from 'loracoms/Toolbar';
import RichLabel from 'loracoms/RichLabel';
import Select from 'loracoms/Select';
import ControlTips from 'loracoms/ControlTips';
import FormBlock from 'loracoms/FormBlock';
import IntlMsg from 'lorautils/intl/IntlMsg';
import { callAPI } from 'lorautils/api';
import { enumsToOptions } from 'lorautils/api/selector';
import enumsActions from 'loraactions/enums';
import ErrorSet from 'lorautils/errors/ErrorSet';
import FixedChannels from '../FixedChannels';
import ChannelsDraft from '../ChannelsDraft';
import AddChannelForm from '../AddChannelForm';
import styles from './styles.scss';

const propTypes = {
  intl: React.PropTypes.any.isRequired,
  pushState: React.PropTypes.func.isRequired,
  bandOpts: React.PropTypes.array.isRequired,
  getBands: React.PropTypes.func.isRequired,
};

class AddChannelPlan extends React.Component {

  constructor(props) {
    super(props);
    this.band = 'CN470';
    this.state = {
      bandOpts: props.bandOpts,
      band: this.band,
      errors: (
        ErrorSet.createEmpty()
          .add('FE_EMPTY', 'name')
      ),
      channelType: 'lora',
      channels: [],
      selected: [],
    };
    this.queue = 0;
    this.show = null;
    this.intlMsg = new IntlMsg(props.intl, 'network.channelview.add');
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleEditDr = this.handleEditDr.bind(this);
    this.handleAddChannel = this.handleAddChannel.bind(this);
    this.handleChangeName = this.handleChangeName.bind(this);
    this.handleChangeBand = this.handleChangeBand.bind(this);
    this.handleDeleteChannel = this.handleDeleteChannel.bind(this);
  }

  componentWillMount() {
    this.loadChannelDefines();
    this.loadDataRates();
    const { getBands } = this.props;
    getBands();
  }

  componentWillReceiveProps(nextProps) {
    const { bandOpts } = nextProps;
    if (bandOpts !== this.props.bandOpts) {
      this.setState({ bandOpts });
    }
  }

  loadChannelDefines() {
    if (!_.isNil(this.band)) {
      callAPI({
        endpoint: `/lora/band/${this.band}/channeldefines`,
      }).then((data) => {
        this.setState({
          mode: data.mode,
          channels: data.channels,
          reserved: data.reserved || [],
        });
      }).catch(() => {});
    }
  }

  loadDataRates() {
    if (!_.isNil(this.band)) {
      callAPI({
        endpoint: `/lora/band/${this.band}/datarates`,
      }).then((data) => {
        this.setState({ dataRates: data });
      }).catch(() => {});
    }
  }

  handleChangeName(e) {
    const { errors } = this.state;
    const name = e.target.value;
    if (name.trim() === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'name') });
    } else {
      this.setState({ errors: errors.remove('name') });
    }
    this.setState({ name });
  }

  handleChangeBand(band) {
    this.setState({ band });
    if (band !== this.band) {
      this.setState({ selected: [], mode: '' });
    }
    this.band = band;
    this.loadChannelDefines();
    this.loadDataRates();
  }

  handleAddChannel(channel) {
    const { selected = [], reserved = [] } = this.state;
    let newChannel = channel;
    if (!_.has(newChannel, 'id')) {
      newChannel = {
        ...newChannel,
        id: reserved.length + selected.length,
      };
    }
    this.setState({
      selected: _.concat(selected, newChannel),
    });
  }

  handleDeleteChannel(channel) {
    const { selected } = this.state;
    this.setState({ selected: selected.filter(ch => ch.id !== channel.id) });
  }

  handleSubmit() {
    this.setState({ submitted: true });

    let { errors } = this.state;
    errors = errors.remove('submit');

    if (!errors.isEmpty()) {
      return;
    }

    const { pushState } = this.props;
    const { name, band, selected = [], reserved = [] } = this.state;
    const channels = _.concat(reserved, selected);
    if (channels.length === 0) {
      this.setState({ errors: errors.add('FE_CHANNEL.EMPTY', 'submit') });
      return;
    }
    callAPI({
      endpoint: '/lora/chplans',
      method: 'POST',
      body: {
        name,
        band,
        channels,
      },
    }).then(() => {
      pushState('/network/chplans');
    }).catch((error) => {
      this.setState({ errors: errors.add(error.code, 'submit') });
    });
  }

  handleEditDr(ch) {
    const { selected, reserved = [] } = this.state;
    const selectedIndex = _.findIndex(selected, s => s.id === ch.id);
    const reservedIndex = _.findIndex(reserved, r => r.id === ch.id);
    if (selected.length && selectedIndex > -1) {
      selected[selectedIndex] = ch;
    } else if (reserved.length && reservedIndex > -1) {
      reserved[reservedIndex] = ch;
    }
    this.setState({ selected, reserved });
  }

  renderAddForm() {
    const { band, bandOpts, errors, submitted = false } = this.state;

    return (
      <Form horizontal className={styles.basicForm}>
        <FormGroup validationState={submitted && errors.has('name') ? 'error' : undefined}>
          <Col md={2}>
            <ControlLabel bsClass="aisz-control-label">
              {this.intlMsg.msg('name')}
            </ControlLabel>
          </Col>
          <Col md={8}>
            <FormControl
              autoFocus
              bsClass="aisz-form-control-f"
              placeholder={this.intlMsg.msg('name.placeholder')}
              onChange={this.handleChangeName}
            />
            <HelpBlock className="aisz-help-block">
              <i className="fa fa-info-circle" />&nbsp;
              {this.intlMsg.msg('nametip')}
            </HelpBlock>
            <ControlTips
              show={submitted && errors.has('name')}
              message={this.intlMsg.errorMsg(errors.get('name'))}
              azStyle="danger"
            />
          </Col>
        </FormGroup>
        <FormGroup>
          <Col md={2}>
            <ControlLabel bsClass="aisz-control-label">
              {this.intlMsg.msg('band')}
            </ControlLabel>
          </Col>
          <Col md={8}>
            <Select
              value={band}
              options={bandOpts}
              onChange={this.handleChangeBand}
            />
          </Col>
        </FormGroup>
      </Form>
    );
  }

  renderAddChannel() {
    const {
      mode = '',
      band,
      selected = [],
      channels = [],
      reserved = [],
      dataRates = {},
    } = this.state;
    if (mode === '') {
      return (
        <div className={styles.loading}>
          <i className="fa fa-spinner fa-spin fa-5x" />
        </div>
      );
    } else if (mode === 'fixed') {
      return (
        <FixedChannels
          band={band}
          selected={selected}
          channels={channels}
          onSelect={this.handleAddChannel}
          onUnselect={this.handleDeleteChannel}
          maxSelected={16}
        />
      );
    }
    return (
      <AddChannelForm
        band={band}
        dataRates={dataRates}
        channels={_.concat(selected, reserved)}
        onAdd={this.handleAddChannel}
      />
    );
  }

  renderToolbar() {
    const { pushState } = this.props;
    const breadcrumb = [{
      content: this.intlMsg.msg('firstnav'),
      onClick: () => pushState('/network/chplans'),
    }, {
      content: this.intlMsg.msg('secondnav'),
      active: true,
    }];
    return <Toolbar breadcrumb={breadcrumb} />;
  }

  render() {
    const {
      selected = [],
      reserved = [],
      dataRates = {},
      errors,
      submitted = false,
    } = this.state;

    return (
      <Grid fluid>
        <Row>
          <Col md={12}>
            {this.renderToolbar()}
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <Panel bsStyle="aisz-white" header={this.intlMsg.msg('panelheader')}>
              <Row>
                <Col md={7}>
                  {this.renderAddForm()}
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <div className={styles.addChannel}>
                    <Row>
                      <Col md={7}>
                        {this.renderAddChannel()}
                      </Col>
                      <Col md={5}>
                        <ChannelsDraft
                          reserved={reserved}
                          channels={selected}
                          dataRates={dataRates}
                          maxChannels={16}
                          onDelete={this.handleDeleteChannel}
                          onEdit={this.handleEditDr}
                        />
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <div className={styles.submit}>
                    <Button
                      bsStyle="aisz-success"
                      onClick={this.handleSubmit}
                    >
                      {this.intlMsg.msg('submit')}
                    </Button>
                  </div>
                  <div className={styles.submitTips}>
                    <FormBlock
                      show={submitted && errors.has('submit')}
                      message={this.intlMsg.errorMsg(errors.get('submit'))}
                      azStyle="danger"
                    />
                  </div>
                </Col>
              </Row>
            </Panel>
          </Col>
        </Row>
      </Grid>
    );
  }
}

AddChannelPlan.propTypes = propTypes;

const mapStateToProps = state => ({
  bandOpts: enumsToOptions('bands', state).map(
    opt => ({ ...opt, formatter: x => <RichLabel content={x} /> })),
});

const dispatchToProps = {
  pushState: routerActions.push,
  getBands: enumsActions.bands,
};

export default connect(mapStateToProps, dispatchToProps)(
  injectIntl(AddChannelPlan));




// WEBPACK FOOTER //
// ./src/containers/Network/coms/ChannelView/coms/AddChannelPlan/index.jsx